<template>
  <div v-if="globalLoading" class="global-loader">
    <MoonLoader size="75px" color="#ffffff"></MoonLoader>
    <div class="global-loader__loading-text">Loading...</div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';

  export default {
    name: 'GlobalLoader',
    components: {
      MoonLoader,
    },
    computed: {
      ...mapGetters('main', ['globalLoading']),
    },
  };
</script>
